import React, { useMemo, useState, useEffect } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { db } from "../firebase";
import { collection, onSnapshot, query, orderBy } from "firebase/firestore";

const toTitleTR = (s = "") =>
  s
    .toLocaleLowerCase("tr")
    .replace(/\s+/g, " ")
    .trim()
    .split(" ")
    .map((w) => (w ? w[0].toLocaleUpperCase("tr") + w.slice(1) : ""))
    .join(" ");
const CategorySection = ({ setCurrentPage, setSelectedCategory }) => {
  const [fbFirms, setFbFirms] = useState([]);
  useEffect(() => {
    const q = query(collection(db, "firmalar"), orderBy("createdAt", "desc"));
    const unsub = onSnapshot(q, (snap) => {
      setFbFirms(snap.docs.map(d => d.data()));
    });
    return () => unsub();
  }, []);

  const categories = useMemo(() => {
    const map = new Map();
    fbFirms.forEach((f) => {
      const sektorler = f.secilenSektorler?.length
        ? f.secilenSektorler
        : f.sektor ? [f.sektor] : [];
      sektorler.forEach((s) => {
        const label = s.trim();
        if (label) map.set(label, (map.get(label) || 0) + 1);
      });
    });
    return Array.from(map, ([name, count]) => ({ name, count }))
      .sort((a, b) => b.count - a.count);
  }, [fbFirms]);

  const len = categories.length;
  const windowSize = 10;
  const [start, setStart] = useState(0);

  const prev = () => len && setStart((s) => (s - 1 + len) % len);
  const next = () => len && setStart((s) => (s + 1) % len);

  const windowItems = useMemo(() => {
    const out = [];
    for (let i = 0; i < Math.min(windowSize, len || 0); i++) {
      out.push(categories[(start + i) % len]);
    }
    return out;
  }, [categories, start, len]);

  const handleClick = (name) => {
    setSelectedCategory?.(name);
    setCurrentPage?.("firms");
    sessionStorage.setItem("selectedCategory", name);
  };

  return (
    <div
      className="relative pt-4 pb-0 bg-cover bg-center"
      style={{
        backgroundImage: `url('https://images.unsplash.com/photo-1477959858617-67f85cf4f1df?w=1600&q=80')`,
        backgroundAttachment: "fixed",
      }}
    >
      {/* Hafif overlay */}
      <div className="absolute inset-0 bg-black/45" />

      <div className="relative z-10 container mx-auto px-4">
        {len > windowSize && (
          <>
            <button
              type="button"
              onClick={prev}
              aria-label="Önceki"
              className="absolute left-2 top-1/2 -translate-y-1/2 bg-white/10 hover:bg-white/20 text-white p-2 rounded-full backdrop-blur transition z-10"
            >
              <ChevronLeft className="w-5 h-5" />
            </button>
            <button
              type="button"
              onClick={next}
              aria-label="Sonraki"
              className="absolute right-2 top-1/2 -translate-y-1/2 bg-white/10 hover:bg-white/20 text-white p-2 rounded-full backdrop-blur transition z-10"
            >
              <ChevronRight className="w-5 h-5" />
            </button>
          </>
        )}

        <div className="grid grid-cols-5 lg:grid-cols-10 gap-0 mt-2 mb-0">
          {windowItems.map((category, index) => (
            <button
              key={`${category.name}-${index}`}
              type="button"
              onClick={() => handleClick(category.name)}
              className="h-20 lg:h-20 flex flex-col items-center justify-center cursor-pointer transition p-1 hover:brightness-110"
              style={{
                backgroundColor: index % 2 === 0 ? "#2d3748" : "#3a4a5c",
              }}
              title={`${category.name} (${category.count})`}
            >
              <span
                className="block w-full px-0.5 text-white text-[10px] lg:text-sm font-semibold text-center leading-tight line-clamp-2"
                style={{ textShadow: "0 1px 3px rgba(0,0,0,0.8)" }}
              >
                {toTitleTR(category.name)}
              </span>
              <span className="text-white/60 text-[9px] lg:text-xs mt-0.5">
                ({category.count})
              </span>
            </button>
          ))}

          {len > 0 &&
            len < windowSize &&
            Array.from({ length: windowSize - len }).map((_, i) => (
              <div key={`ghost-${i}`} className="h-20 opacity-0" />
            ))}
        </div>
      </div>
    </div>
  );
};

export default CategorySection;
